(() => {
  'use strict';
  const DEFAULT_CARD = 115;
  const DEFAULT_POPUP = 115;
  const HOME_SELECTOR = '[data-jol-homepage][data-jol-global-card-scale][data-jol-global-popup-scale]';
  const clamp = (value, min, max, fallback) => {
    const n = Number(value);
    return Number.isFinite(n) ? Math.min(max, Math.max(min, n)) : fallback;
  };
  function apply(cardPercent, popupPercent) {
    const card = clamp(cardPercent, 80, 140, DEFAULT_CARD);
    const popup = clamp(popupPercent, 80, 140, DEFAULT_POPUP);
    const root = document.documentElement;
    root.style.setProperty('--jol-global-card-manual-factor', (card / 115).toFixed(5));
    root.style.setProperty('--jol-popup-image-scale', (popup / 100).toFixed(5));
    root.dataset.jolGlobalCardScale = String(card);
    root.dataset.jolGlobalPopupScale = String(popup);
    window.dispatchEvent(new CustomEvent('jol:global-image-scales', { detail: { card, popup } }));
  }
  function readFromNode(node) {
    if (!node) return false;
    apply(node.dataset.jolGlobalCardScale, node.dataset.jolGlobalPopupScale);
    return true;
  }
  function homeUrl() {
    const url = new URL('/', window.location.origin);
    const current = new URL(window.location.href);
    ['preview_theme_id', 'preview_key', '_fd', 'pb'].forEach((key) => {
      const value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });
    return url.toString();
  }
  async function loadGlobalValues() {
    if (readFromNode(document.querySelector(HOME_SELECTOR))) return;
    try {
      const response = await fetch(homeUrl(), { credentials: 'same-origin', cache: window.Shopify?.designMode ? 'no-store' : 'default' });
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!readFromNode(doc.querySelector(HOME_SELECTOR))) apply(DEFAULT_CARD, DEFAULT_POPUP);
    } catch (_) {
      apply(DEFAULT_CARD, DEFAULT_POPUP);
    }
  }
  function init() {
    loadGlobalValues();
    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      const home = target?.matches?.(HOME_SELECTOR) ? target : target?.querySelector?.(HOME_SELECTOR);
      if (home) readFromNode(home);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
